import { Popover } from "@mui/material";
import React, { useEffect, useState, useContext } from "react";
import InputForm from "../../../Components/InputForm/InputForm";
import { makeStyles } from "@mui/styles";
import notify, { ToastType } from "../../../Helpers/ToastNotification";
import {
  ApplicationStatus,
  LoanStatus,
} from "../../../Helpers/Enums/ApplicationStatus";
import { APICall } from "../../../Helpers/Network/APICalls";
import {
  updateLoanCommitteeApproval,
  updateLoanRequestStateId,
} from "../../../Helpers/APIEndPoints/EndPoints";
import { useNavigate } from "react-router-dom";
import ButtonComponent from "../../../Components/ButtonForm/Button";
import Checkbox from "../../../Components/Checkbox/Checkbox";

import SelectForm from "../../../Components/SelectForm/SelectForm";
import { Modules } from "../../../Helpers/Enums/Modules";
import { getContext } from "../../../Helpers/Context/Context";
import { RoleEnum } from "../../../Helpers/Enums/RoleEnum";
import { LoaderContext } from "../../../Helpers/Context/Context";
import { ApiStatus } from "../../../Helpers/Enums/ApiStatus";
import { Modal, Button } from 'react-bootstrap';


const MailModel = ({ show, handleClose, handleConfirm }) => {
  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header className="custom-modal-header" closeButton>
        <Modal.Title>Confirm Action</Modal.Title>
      </Modal.Header>
      <Modal.Body>Are you sure you want to send the mail?</Modal.Body>
      <Modal.Footer>      
        <Button  className="btn-save text-center" onClick={handleConfirm}>
          Yes
        </Button>
        <Button className="text-center btn-submit mr-3"  onClick={handleClose}>
          No
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default MailModel;
